import React, {lazy, Suspense } from 'react';
import Dashboard from '../../components/Dashboard/Dashboard';
import LazyLoader from '../../components/MasterLayout/LazyLoader';
const ManageProfile = lazy(()=>import('../../components/Dashboard/ManageProfile'))

const ManageProfilePage = () => {
    return (
        <Dashboard>
            <Suspense fallback={<LazyLoader/>}>
                <ManageProfile/>
            </Suspense>
        </Dashboard>
    );
};

export default ManageProfilePage;